export default __webpack_public_path__ + "static/assets/785276cd2ac25c6b9e7354bfbf9880b0.png";